<template>
  <div :class="customClass">
    <div class="cb-cart" :class="{'cb-cart--multiple': isMultipleCart}">
      <cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
      <line-item :readonly="readonly" :singleCart='!isMultipleCart' :item='item' :singleItem='isSingleItem' :currencyCode='currency_code' v-for="item in order_cart_items" v-bind:key="item.id" :useItem='true'></line-item>
      </cb-slide-n-fade>
      <slot name="addons"></slot>
    </div>
    <div v-if="showCouponDesc" class="cb-cart cb-cart--multiple cb-cart--footer cb-cart--footer-left">
      <div class="cb-item--extras cb-transition__fade">
        <div class="cb-item__name">{{getCouponDetail}}</div>
        <div v-if="coupon_enabled && !readonly" @click="removeDiscount()" class="cb-item__action" v-cb-link="'color'">{{ct('cart.remove')}}</div>
      </div>
    </div>
    <template v-if="coupon_enabled && !showCouponDesc && !readonly" ref="parent">
      <cb-discount></cb-discount>
    </template>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import LineItem from "@/components/modules/hosted-pages/LineItem"
import CartHelper from '@/utils/cart-helper'
import Discount from "@/components/modules/hosted-pages/DiscountComponent"
import {EventBus} from '@/utils/event-bus'
import CartMixin from "@/mixins/cart-mixin"
export default {
  components: {
    'line-item': LineItem,
    'cb-discount': Discount,
  },
  props: ['customClass', 'readonly'],
  mixins: [CartMixin],
  computed: {
    ...mapGetters([
      'order_cart_items',
      'consolidated_discount',
      'currency_code',
      'coupon_enabled',
      'coupon_list'
    ]),
    isMultipleCart() {
      return this.order_cart_items.length > 1 || this.$store.getters.consolidated_tax || this.hasTieredPricing();
    },
    showCouponDesc() {
      return (this.coupon_list.length > 0) && this.getCouponDetail;
    },
    getCouponDetail() {
      let output;
      if(this.consolidated_discount) {
        output = this.consolidated_discount;
      } else if(this.coupon_list.length > 0) {// TODO - Handle later for multi coupon
        let coupon = this.coupon_list[0];
        output = {};
        output.coupon_id = coupon.id;
        output.title = coupon.details.invoice_name || coupon.details.name;
        CartHelper.addSingleCouponDesc(output, this.coupon_list);
      }
      if(output && output.description) {
        return this.ct('coupon.description', {
          coupon_name: output.title,
          amount: output.description()
        });
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .cb-item__name{
    margin-right: 12px;
    width: auto !important;
  }
</style>


// WEBPACK FOOTER //
// CartItems.vue?6583e5d0